import React from "react";

const TodoRoute = ({ children }) => {
    return children;
};

export default TodoRoute;
